var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body p-0" }, [
      _c("div", { staticClass: "row p-2" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("suc-date-period-component", {
              attrs: { type: _vm.type },
              on: _vm._d({}, [_vm.periodChangedEvent, _vm.periodChanged]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col text-right" },
          [
            _vm.dayEnabled
              ? [
                  _c(
                    "span",
                    {
                      class: { "period-active": _vm.isDay, period: !_vm.isDay },
                      on: { click: _vm.setDayPeriod },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.fields.day")))]
                  ),
                  _vm._v(" | "),
                ]
              : _vm._e(),
            _vm.weekEnabled
              ? [
                  _c(
                    "span",
                    {
                      class: {
                        "period-active": _vm.isWeek,
                        period: !_vm.isWeek,
                      },
                      on: { click: _vm.setWeekPeriod },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.fields.week")))]
                  ),
                ]
              : _vm._e(),
            _vm.monthEnabled
              ? [
                  _vm._v(" | "),
                  _c(
                    "span",
                    {
                      class: {
                        "period-active": _vm.isMonth,
                        period: !_vm.isMonth,
                      },
                      on: { click: _vm.setMonthPeriod },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.fields.month")))]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }